import { InjectionToken, Injectable, Inject, NgModule } from '@angular/core';

import * as ɵngcc0 from '@angular/core';
const EnvironmentModuleConfigToken = new InjectionToken('environment_module_config');

class EnvironmentService {
    constructor(config) {
        this.config = config;
    }
}
EnvironmentService.ɵfac = function EnvironmentService_Factory(t) { return new (t || EnvironmentService)(ɵngcc0.ɵɵinject(EnvironmentModuleConfigToken)); };
EnvironmentService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: EnvironmentService, factory: EnvironmentService.ɵfac });
EnvironmentService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [EnvironmentModuleConfigToken,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EnvironmentService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [EnvironmentModuleConfigToken]
            }] }]; }, null); })();

class EnvironmentModule {
    static forRoot(environment) {
        return {
            ngModule: EnvironmentModule,
            providers: [EnvironmentService, { provide: EnvironmentModuleConfigToken, useValue: environment }],
        };
    }
}
EnvironmentModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: EnvironmentModule });
EnvironmentModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function EnvironmentModule_Factory(t) { return new (t || EnvironmentModule)(); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EnvironmentModule, [{
        type: NgModule,
        args: [{
                bootstrap: []
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { EnvironmentModule, EnvironmentModuleConfigToken, EnvironmentService };

//# sourceMappingURL=mt-ng2-environment-module.js.map